import { useRef, useState } from 'react'
import { url } from '@10000/common'
import { useBreakpoints, useInstance, useNotifications, useRequest, useView } from '@10000/react'
import { useBackground, useShell } from '../../layout'
import { Body, Box, Button, Copy, ElementHighlight, H3, TooltipDialog, TooltipSeries, useTooltipSeries } from '../../widgets'
import { SquizScreen, Toolbar } from '../common'
import { assetUrl } from '../../../utilities.js'
import { ResetTooltips } from '../../analytics'

const audio = new Audio(assetUrl('sounds/cartoon-confirmation-2.wav'))

export const Participants = props => {
  const { options: { guides } } = useView('squiz')
  const [guideActive, setGuideActive] = useState(false)

  return (
    <TooltipSeries
      complete={!guides}
      active={guides || guideActive}
      onReset={() => setGuideActive(true)}
      onComplete={() => setGuideActive(false)}
    >
      <ParticipantsScreen {...props} />
    </TooltipSeries>
  )
}

export const ParticipantsScreen = ({ active }) => {
  const { participants = [] } = useView('squiz')
  const request = useRequest('squiz')
  const { notify } = useNotifications()
  const { next, tip } = useTooltipSeries()

  const { mobile } = useBreakpoints()

  useBackground().set(mobile => mobile ? { active, background: null } : { active, background: 1, fade: true, size: '2072px 2035px', position: '-816px -592px' })
  useShell({ active, mode: 'authenticated left-aligned' })
  const { id, region } = useInstance()

  const presentationRef = useRef()
  const teamMembersRef = useRef()
  const controlsRef = useRef()
  const mobileControlRef = useRef()
  const startButtonRef = useRef()

  const incrementTutorial = validPosition => {
    if(tip === validPosition || typeof validPosition !== 'number' && tip >= 0) {
      next()
    }
  }

  const openDisplay = () => {
    window.open(url.game('shivoo', id, { region, view: 'display' }))
    incrementTutorial(1)
  }

  const copyUrl = () => {
    try {
      navigator.clipboard.writeText(url.game('shivoo', id, { region }))
      notify(`Copied to clipboard`, 'info')
    } catch {
      notify(`Couldn't copy to clipboard`)
    }
  }
  const start = () => request('squizStarted')

  return (
    <SquizScreen fade participants participantsDesktopOnly={false} fullHeightContent={false} ref={teamMembersRef}>
      <Box column maxWidth={400} gap={16} alignItems="center" ref={controlsRef}>
        <H3 align="center">Your Squiz is ready to start</H3>

        {/*<Box*/}
        {/*  gap={4}*/}
        {/*  alignItems="center"*/}
        {/*  cursor="pointer"*/}
        {/*  onClick={copyUrl}*/}
        {/*>*/}
        {/*  <Body>Squiz code <b>YOS7</b></Body>*/}
        {/*  <Icon icon="Copy" size={24}/>*/}
        {/*</Box>*/}

        <Box onClick={copyUrl} cursor="pointer">
          <Body align="center">
            Click to copy join link &nbsp;<Copy size={16} />
          </Body>
        </Box>
        <Box className="desktop-only" />

        <Box className="mobile-footer" column gap={16} zIndex={5}>
          <Box className="desktop-only">
            <Button fullWidth onClick={openDisplay} ref={presentationRef}>
              Open presentation screen
            </Button>
          </Box>
          <Box gap={16}>
            {mobile && (
              <Box
                justifyContent="center"
                alignItems="center"
                ref={mobileControlRef}
                r={28}
              >
                <Toolbar mobileOnly onCloseMobile={() => incrementTutorial()} />
              </Box>
            )}
            <Button
              ref={startButtonRef}
              fullWidth
              onClick={start}
              disabled={participants.length === 0}
            >
              Enter Squiz
            </Button>
          </Box>
        </Box>

        <ResetTooltips />
      </Box>

      {!mobile && <TooltipDialog
        order={0}
        title="Open presentation screen"
        text="Click 'Open presentation screen' to open a new tab. Drag this tab to your second screen and go full-screen for optimal viewing."
        buttonText="Next"
        image="presentation-screen"
      />}
      {!mobile && <ElementHighlight
        order={1}
        target={presentationRef}
      />}
      <TooltipDialog
        order={2}
        title="Check your sound"
        text="Play this sound to make sure your speakers are working."
        buttonText="Next"
        image="sound"
      >
        <Box fullWidth justifyContent="center" cursor="pointer" onClick={() => audio.play()}>
          <Body color="black" alt underline bold>
            Play sound
          </Body>
        </Box>
      </TooltipDialog>
      <TooltipDialog
        order={3}
        title="Your controls"
        text="Check out your facilitator controls."
        buttonText="Next"
        image={mobile ? 'mobile-controls' : 'toolbar'}
      />
      {mobile && <ElementHighlight
        order={4}
        target={mobileControlRef}
        pointDirection="left-down"
      />}
      {!mobile && <ElementHighlight
        order={4}
        target="#toolbar"
        nextOnFinish
      />}
      <TooltipDialog
        order={5}
        title="You’re ready to start"
        text="Once your team members have joined you’re ready to start"
        buttonText="OK"
        image="participants"
      />
      <ElementHighlight
        order={6}
        target={teamMembersRef}
        pointDirection={mobile ? 'right-down-middle' : 'right-up'}
        nextOnFinish
      />
      <ElementHighlight
        order={7}
        target={startButtonRef}
        pointDirection={mobile ? 'down' : 'left-up'}
        nextOnFinish
      />
    </SquizScreen>
  )
}